import { cue } from '../audio/cues.js';

/**
 * The interface's named sounds, kept for the panels that call them. They
 * used to be tones synthesised on the spot; they are now the generated
 * effects of the sound pack (ADR 0019), played through `audio/`.
 */

/** The anvil rings, then a bright rising chime. */
export function playUpgradeSuccess(): void {
  cue('sfx.upgrade-success');
}

/** A dull clank falling away. */
export function playUpgradeFail(): void {
  cue('sfx.upgrade-fail');
}

/** The portal's rush (ADR 0017): air drawn upward, and glassy tones climbing. */
export function playTeleport(): void {
  cue('sfx.teleport');
}
